import Head from 'next/head'
import { useTranslation } from 'next-i18next'

interface Props {
  title: string
  description?: string
  image?: string
  url?: string
  canonical?: string
  noindex?: boolean
  keywords?: string
  author?: string
  lang?: string
  withoutPostfix?: boolean
}

export default function Meta({
  title,
  description = '',
  image = 'https://cdn.naviparking.com/digital_parking/img/og.webp',
  url,
  canonical,
  noindex = false,
  keywords,
  author = 'NaviParking',
  lang = 'pl',
  withoutPostfix
}: Props) {
  const { t } = useTranslation('common')
  const postfix = withoutPostfix ? '' : ` — ${t('digitalParking')}`

  const pageTitle = title + postfix
  const href = canonical || url

  return (
    <Head>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords || ''} />
      <meta name="author" content={author} />
      <meta
        name="robots"
        content={noindex ? 'noindex,nofollow' : 'index,follow'}
      />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      {href && <meta property="og:url" content={href} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {href && <link rel="canonical" href={href} />}
    </Head>
  )
}
